
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign/lifecycle",
      function () {
        return require("private-next-pages/sign/lifecycle.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign/lifecycle"])
      });
    }
  